var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2724A",
  d: "M39.8,38L23.4,5.6c-0.2-0.5-0.8-0.7-1.3-0.5c-0.2,0.1-0.4,0.3-0.5,0.5L5.1,38c-0.1,0.4-0.1,0.8,0,1.2 c0.2,0.4,0.6,0.7,1,0.7h32.8c0.7-0.1,1.2-0.6,1.1-1.3c0,0,0,0,0,0C40,38.4,39.9,38.2,39.8,38z M7.9,37.5L22.5,8.7l14.6,28.7H7.9z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M7.9,37.5h29.2L22.5,8.7L7.9,37.5z M23.4,14.1l10,19.6c0.1,0.2,0.1,0.5,0.1,0.7c0,0.7-0.4,1.2-1,1.2h-20 c-0.4,0-0.7-0.2-0.9-0.6c-0.2-0.4-0.2-0.8,0-1.2l10-19.7c0.2-0.5,0.8-0.7,1.3-0.5C23.1,13.8,23.3,13.9,23.4,14.1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M14.4,33.2h16.2l-8.1-16.1L14.4,33.2z M23.2,32.5c-0.2,0.2-0.4,0.4-0.7,0.4c-0.7-0.1-1.2-0.6-1.1-1.3 c0,0,0,0,0,0c0-0.3,0.1-0.6,0.3-0.8c0.2-0.3,0.5-0.4,0.8-0.4c0.3,0,0.6,0.2,0.7,0.4c0.2,0.2,0.4,0.5,0.4,0.8 C23.6,31.9,23.4,32.2,23.2,32.5z M23.6,21.6v7c0,0.6-0.5,1.1-1.1,1.2c-0.6-0.1-1.1-0.6-1.1-1.2v-7c0-0.6,0.5-1.1,1.1-1.2 C23.1,20.4,23.6,20.9,23.6,21.6z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#4AB8DC",
  d: "M21.6,14.1l-10,19.7c-0.2,0.4-0.2,0.8,0,1.2c0.2,0.4,0.5,0.6,0.9,0.6h20c0.6,0,1-0.5,1-1.2 c0-0.2,0-0.5-0.1-0.7l-10-19.6c-0.2-0.5-0.8-0.7-1.3-0.5C21.9,13.8,21.7,13.9,21.6,14.1z M30.6,33.2H14.4l8.1-16.1L30.6,33.2z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#28B557",
  d: "M21.4,21.5v7c0,0.6,0.5,1.1,1.1,1.2c0.6-0.1,1.1-0.6,1.1-1.2v-7c0-0.6-0.5-1.1-1.1-1.2 C21.9,20.4,21.4,20.9,21.4,21.5z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#28B557",
  d: "M22.5,30.3c-0.3,0-0.6,0.1-0.8,0.4c-0.2,0.2-0.3,0.5-0.3,0.8c-0.1,0.7,0.4,1.2,1.1,1.3c0,0,0,0,0,0 c0.3,0,0.5-0.2,0.7-0.4c0.2-0.2,0.4-0.6,0.4-0.9c0-0.3-0.2-0.6-0.4-0.8C23.1,30.5,22.8,30.3,22.5,30.3z"
});

function SvgEhsConcern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhsConcern);
export default __webpack_public_path__ + "static/media/ehs_concern.a20dfb205a1267415b5aa14dcfe6f5a3.svg";
export { ForwardRef as ReactComponent };